
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_brdst_1m15f_9",
  "loading": "awsui_loading_brdst_1m15f_13",
  "undo-button": "awsui_undo-button_brdst_1m15f_17"
};
  